import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import AppBaseComponent from '../../../components/AppBaseComponent';
import tapIcon from "../../../services/TapIcon";
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from 'react-toastify';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapInputNumber from '../../../components/ui/TapInputNumber';

class POCancel extends AppBaseComponent {
    
    constructor(props) {
        super(props);

        this.cancelItemFormInit = {
            notes: '',
        }

        this.state = {
            cancelledItemList: [],
            cancel_item_loading: false,
            cancelItemFormSubmitting: false,
            cancelledItemForm: { ...this.cancelItemFormInit },
            poTransactionId: null
        };
        
        this.purchaseOrderUrl = INVENTORY_API_BASE_URL_2 + '/purchase_order';
    }
    
    componentDidMount() {
        this.cancelledItemModal = new Modal(document.getElementById('poCancelledItemModal'), { keyboard: false, backdrop: false });
    }

    modalInit = (cancelItemList, poTransactionId) => {
        // Map req_allocation to have new_cancelled_qty for each allocation
        let updatedList = cancelItemList.map(item => {
            let updatedItem = { ...item };
            if (item.req_allocation && item.req_allocation.length > 0) {
                updatedItem.req_allocation = item.req_allocation.map(req => ({
                    ...req,
                    new_cancelled_qty: ''
                    // new_cancelled_qty: req.pending_qty || 0
                }));
            }
            return updatedItem;
        });

        this.setState({
            cancelledItemList: updatedList,
            poTransactionId: poTransactionId,
            cancelledItemForm: { ...this.cancelItemFormInit }
        }, () => {
            this.cancelledItemModal.show();
        });
    }

    changeCancelledItemHandler = (value, key1, key2, name) => {

    let cancelledItemList = [...this.state.cancelledItemList];

    if (cancelledItemList[key1]?.req_allocation?.[key2]) {

        cancelledItemList[key1].req_allocation[key2][name] = value;

    } else {

        cancelledItemList[key1].new_cancelled_qty = value;
    }

    this.setState({ cancelledItemList });
}

    changeItemCancelledQtyHandler = (newValue, itemIndex, fieldName) => {
        const updatedList = [...this.state.cancelledItemList];
        updatedList[itemIndex] = {
            ...updatedList[itemIndex],
            [fieldName]: newValue
        };
        this.setState({ cancelledItemList: updatedList });
    }

    submitCancelItemForm = (e) => {
        e.preventDefault();

        let items = [...this.state.cancelledItemList];

        let itemsLists = items
            .filter(i => {
                const itemQty = parseFloat(i.new_cancelled_qty || 0);
                const reqQty =
                    i.req_allocation?.reduce(
                        (sum, r) => sum + parseFloat(r.new_cancelled_qty || 0),
                        0
                    ) || 0;

                return (itemQty + reqQty) > 0;
            })
            .map(i => {

                let new_cancelled_qty =
                    i.new_cancelled_qty
                        ? i.new_cancelled_qty
                        : 0;

                let total_req_qty =
                    i.req_allocation && i.req_allocation.length > 0
                        ? parseFloat(
                            i.req_allocation.reduce(
                                (s, b) =>
                                    s + parseFloat(
                                        b.new_cancelled_qty
                                            ? b.new_cancelled_qty
                                            : 0
                                    ),
                                0
                            )
                        )
                        : 0;

                return {
                    po_item_id: i.po_item_id,
                    transaction_id: i.transaction_id || this.state.poTransactionId,
                    qty: parseFloat(new_cancelled_qty) + total_req_qty,
                    req_allocation:
                        i.req_allocation && i.req_allocation.length > 0
                            ? i.req_allocation
                                .filter(r => parseFloat(r.new_cancelled_qty || 0) > 0)
                                .map(r => ({
                                    qty: parseFloat(r.new_cancelled_qty),
                                    req_item_id: r.req_item_id
                                }))
                            : []
                };
            });

        let formData = {
            items: itemsLists,
            notes: this.state.cancelledItemForm.notes
        };

        this.setState({ cancelItemFormSubmitting: true });

        HttpAPICall.withAthorization(
            'PUT',
            this.purchaseOrderUrl + '/cancel_item',
            this.props.access_token,
            {},
            { ...formData },
            (response) => {

                toast.success(response.data.msg, {
                    position: toast.POSITION.TOP_RIGHT
                });

                this.cancelledItemModal.hide();

                this.setState({
                    cancelledItemList: [],
                    cancelledItemForm: {
                        ...this.cancelItemFormInit
                    }
                });

                if (this.props.getPODetail) {
                    this.props.getPODetail(this.state.poTransactionId);
                }

                if (this.props.onCancelComplete) {
                    this.props.onCancelComplete(this.state.poTransactionId);
                }
            }
        )
            .catch((error) => {
                toast.error(
                    error.response?.data?.msg ||
                    'Failed to cancel items',
                    {
                        position: toast.POSITION.TOP_RIGHT
                    }
                );
            })
            .then(() =>
                this.setState({
                    cancelItemFormSubmitting: false
                })
            );
    }

    formInputHandler = (e, formName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [e.target.name]: e.target.value
            }
        });
    }

    //***********************CANCEL ITEM JSX****************
    cancelledItemModalJsx = () => {
        return (
            <div className="modal fade" id="poCancelledItemModal" tabIndex="-1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Cancel PO Items</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => { this.setState({ cancelledItemList: [] }); }}
                            />
                        </div>
                        <form onSubmit={this.submitCancelItemForm}>
                            <div className="modal-body">
                                {this.state.cancel_item_loading ? <Loader />
                                    : <Ax>
                                        <div className="table-responsive">
                                            <table className="table table-bordered bg-white table-sm">
                                                <thead className="table-secondary">
                                                    <tr className="text-end">
                                                        <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                                        <th scope="col" style={{ width: "25%" }} className="text-start">Item Details</th>
                                                        <th scope="col" style={{ width: "10%" }} className="text-center">Requisition</th>
                                                        <th scope="col" style={{ width: "8%" }} className="text-end">Qty</th>
                                                        <th scope="col" style={{ width: "8%" }} className="text-end">Received</th>
                                                        <th scope="col" style={{ width: "8%" }} className="text-end">Cancelled</th>
                                                        <th scope="col" style={{ width: "8%" }} className="text-end">Pending</th>
                                                        <th scope="col" style={{ width: "10%" }} className="text-end">New Cancelled</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.cancelledItemList.length > 0 ? (
                                                        this.state.cancelledItemList.map((i, k) => {
                                                            // Check if item has req_allocation
                                                            let reqAllocations = [];

                                                            if (i.req_allocation && i.req_allocation.length > 0) {

                                                                reqAllocations =
                                                                    i.additional_qty > 0
                                                                        ? [
                                                                            ...i.req_allocation,
                                                                            {
                                                                                requisition_transaction_id: 'ADDL',
                                                                                qty: i.additional_qty,
                                                                                pending_qty:
                                                                                    Number(i.pending_qty || 0) -
                                                                                    i.req_allocation
                                                                                        .map(s => Number(s.unreceived_qty || 0))
                                                                                        .reduce((a, b) => a + b, 0),
                                                                                new_cancelled_qty: 0
                                                                            }
                                                                        ]
                                                                        : [...i.req_allocation];

                                                            } else {

                                                                reqAllocations = [{
                                                                    requisition_transaction_id: '-',
                                                                    qty: i.qty || 0,
                                                                    pending_qty: i.pending_qty || 0,
                                                                    new_cancelled_qty: i.new_cancelled_qty || 0,
                                                                    req_item_id: i.req_item_id || null
                                                                }];
                                                            }

                                                            return (
                                                                <Ax key={k}>
                                                                    {reqAllocations.map((req, key) => {
                                                                        let pending_qty =
                                                                            req?.unreceived_qty ??
                                                                            req?.pending_qty ??
                                                                            0;

                                                                        return (
                                                                            <tr key={`${k}-${key}`}>
                                                                                {key === 0 ? (
                                                                                    <td rowSpan={reqAllocations.length > 1 ? reqAllocations.length : 1} className="align-middle text-center">
                                                                                        {k + 1}
                                                                                    </td>
                                                                                ) : null}
                                                                                {key === 0 ? (
                                                                                    <td rowSpan={reqAllocations.length > 1 ? reqAllocations.length : 1} className="align-middle">
                                                                                        {i.item ? (
                                                                                            <div>
                                                                                                <span className="fw-bold">{i.item.name}</span>
                                                                                                <br />
                                                                                                <div className="form-text">
                                                                                                    <b>Code: </b>{i.item.item_code}
                                                                                                </div>
                                                                                                <div className="form-text">
                                                                                                    <b>Mfr: </b>{i.item?.manufacturer?.name ?? '-'}
                                                                                                    (MPN: {i.item?.manufacturer_part_no ?? "-"})
                                                                                                </div>
                                                                                                <div className="form-text">
                                                                                                    {i.item?.tags?.length > 0 ? (
                                                                                                        i.item.tags.map((tag, idx) => (
                                                                                                            <span key={idx} className="badge bg-secondary me-1">{tag.name}</span>
                                                                                                        ))
                                                                                                    ) : '-'}
                                                                                                </div>
                                                                                                <div className="form-text">
                                                                                                    <b>Remark: </b>{i.remark ?? "-"}
                                                                                                </div>
                                                                                                {i.item.measuring_unit?.name && (
                                                                                                    <div className="form-text">
                                                                                                        <b>Unit: </b>{i.item.measuring_unit.name}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        ) : null}
                                                                                    </td>
                                                                                ) : null}
                                                                                <td className="text-center">
                                                                                    {req.requisition_transaction_id || '-'}
                                                                                </td>
                                                                                <td className="text-end">{req.qty || 0}</td>
                                                                                <td className="text-end">{i.received_qty || 0}</td>
                                                                                {key === 0 ? (
                                                                                    <td className="text-end" rowSpan={reqAllocations.length > 1 ? reqAllocations.length : 1}>
                                                                                        {i.cancelled_qty || 0}
                                                                                    </td>
                                                                                ) : null}
                                                                                <td className="text-end">{pending_qty}</td>
                                                                                <td className="text-end">
                                                                                    <TapInputNumber

                                                                                        onChange={(newValue) => {
                                                                                            this.changeCancelledItemHandler(
                                                                                                newValue,
                                                                                                k,
                                                                                                key,
                                                                                                'new_cancelled_qty'
                                                                                            );
                                                                                        }}
                                                                                        name="new_cancelled_qty"
                                                                                        value={req.new_cancelled_qty || 0}
                                                                                        className="form-control text-end"
                                                                                        placeholder="Qty"
                                                                                        
                                                                                        max={pending_qty}
                                                                                        min={0}
                                                                                        step={0.01}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </Ax>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td className="text-center" colSpan={8}>No items to cancel</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row align-items-center mt-3">
                                            <div className="col-sm-6">
                                                <label htmlFor="notes" className="form-label">Notes</label>
                                                <textarea
                                                    name="notes"
                                                    value={this.state.cancelledItemForm.notes}
                                                    onChange={(e) => this.formInputHandler(e, 'cancelledItemForm')}
                                                    className="form-control"
                                                    style={{ height: "100px" }}
                                                    placeholder="Enter cancellation notes..."
                                                />
                                            </div>
                                        </div>
                                    </Ax>
                                }
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    disabled={this.state.cancelItemFormSubmitting}
                                    onClick={() => { this.setState({ cancelledItemList: [] }); }}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={this.state.cancelItemFormSubmitting}
                                >
                                    Save {this.state.cancelItemFormSubmitting ? (
                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />
                                    ) : ''}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

render() {
    return <Ax>{this.cancelledItemModalJsx()}</Ax>;
}
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(POCancel);